import { ACTION_FLEX_MESSAGE_TEMPLATE } from './actions'
import { IFlexMessageTemplate } from '@/utils/types'
import { apiListChangedHandler } from '@/utils/helpers'
import flexMessageTemplateApi from '@/api/flexMessageTemplate'
import cloneDeep from 'lodash/cloneDeep'
import { localStore } from '@/utils/localstore'
import { constant } from '@/utils/constants'

type TState = {
  items: IFlexMessageTemplate[]
  loading: boolean
}

export default {
  state: {
    items: [],
    loading: false,
  },
  getters: {
    flexMessagetemplates: (state: TState) => {
      return state.items as IFlexMessageTemplate[]
    },
  },
  mutations: {
    // [List]
    [ACTION_FLEX_MESSAGE_TEMPLATE.SET_ITEMS]: (state: TState, { items }: { items: IFlexMessageTemplate[] }) => {
      state.items = cloneDeep(items) as IFlexMessageTemplate[]
    },

    // [New item]
    [ACTION_FLEX_MESSAGE_TEMPLATE.SET_NEW_ITEM]: (state: TState, { item }: { item: IFlexMessageTemplate }) => {
      state.items = apiListChangedHandler<IFlexMessageTemplate>(state.items, cloneDeep(item), 'inserted')
    },

    // [UPDATE]]
    [ACTION_FLEX_MESSAGE_TEMPLATE.SET_UPDATED_ITEM]: (state: TState, { item }: { item: IFlexMessageTemplate }) => {
      state.items = apiListChangedHandler<IFlexMessageTemplate>(state.items, cloneDeep(item), 'modified')
    },

    // [Deleted item]
    [ACTION_FLEX_MESSAGE_TEMPLATE.SET_DELETED_ITEM]: (state: TState, { item }: { item: IFlexMessageTemplate }) => {
      state.items = apiListChangedHandler<IFlexMessageTemplate>(state.items, cloneDeep(item), 'removed')
    },
  },
  actions: {
    // eslint-disable-next-line
    [ACTION_FLEX_MESSAGE_TEMPLATE.LOAD_ITEMS]: async ({ commit }, payload: IFlexMessageTemplate) => {
      const key = constant.LOCAL_KEYS.FLEX_MESSAGE_TEMPLATE + payload.app_id + JSON.stringify(payload)
      let resp
      resp = localStore.getWithExpiry(key)
      if (!resp) {
        resp = await flexMessageTemplateApi.list(payload)
        localStore.setWithExpiry(key, resp, constant.LOCAL_EXPIRED)
      }

      commit(ACTION_FLEX_MESSAGE_TEMPLATE.SET_ITEMS, { items: resp })
      return resp
    },
    // eslint-disable-next-line
    [ACTION_FLEX_MESSAGE_TEMPLATE.LOAD_ITEM]: async ({ commit }, id: string) => {
      return await flexMessageTemplateApi.single(id)
    },

    [ACTION_FLEX_MESSAGE_TEMPLATE.ADD]: async ({ commit }, payload: IFlexMessageTemplate) => {
      const resp = await flexMessageTemplateApi.add(payload)
      if (resp?._id) {
        localStore.removeStartsWith(constant.LOCAL_KEYS.FLEX_MESSAGE_TEMPLATE)
        commit(ACTION_FLEX_MESSAGE_TEMPLATE.SET_NEW_ITEM, { item: resp })
        return resp
      }
      return null
    },
    [ACTION_FLEX_MESSAGE_TEMPLATE.UPDATE]: async ({ commit }, payload: IFlexMessageTemplate) => {
      const resp = await flexMessageTemplateApi.update(payload)
      if (resp?._id) {
        localStore.removeStartsWith(constant.LOCAL_KEYS.FLEX_MESSAGE_TEMPLATE)
        commit(ACTION_FLEX_MESSAGE_TEMPLATE.SET_UPDATED_ITEM, { item: resp })
        return resp
      }
      return null
    },
    [ACTION_FLEX_MESSAGE_TEMPLATE.DELETE]: async ({ commit }, id: string) => {
      const resp = await flexMessageTemplateApi.delete(id)
      if (resp?._id) {
        localStore.removeStartsWith(constant.LOCAL_KEYS.FLEX_MESSAGE_TEMPLATE)
        commit(ACTION_FLEX_MESSAGE_TEMPLATE.SET_DELETED_ITEM, { item: resp })
        return true
      }
    },
  },
}
